import * as React from "react"
import { overlay } from '../pages/styles.module.css'

const Overlay = ()=>{
  return (
    <div className={overlay}></div>
  )
}

export default Overlay
